<template>
  <div
    class="marketplace d-flex flex-column align-items-center justify-content-center"
    :class="!isUserLoggedIn ? 'grey-out m-0' : ''"
  >
    <b-row
      class="marketplace__container flex-column align-items-center justify-content-center"
    >
      <h2 class="marketplace__heading">
        Hi<span v-if="userData && userData.firstName">
          {{ decodeURIComponent(userData.firstName) }}</span
        >, what would you like to see in the
        <span v-if="orgDetails.name">
          {{ decodeURIComponent(orgDetails.name) }}</span
        >
        Market?
      </h2>

      <h4 class="marketplace__subheading">
        We are curating a selection of unique and exciting rewards for you to
        redeem.
      </h4>

      <button class="marketplace__btn" @click="pickReward">
        Pick Reward Type
        <img src="@/assets/images/icons/arrow-right.png" alt="Arrow" />
      </button>
    </b-row>
    <skill-report-modal v-if="talentReportPopup && reportUrl" />
  </div>
</template>
<script>
import { BRow } from "bootstrap-vue";
import SkillReportModal from "@/modals/SkillReportModal.vue";
export default {
  components: {
    BRow,
    SkillReportModal,
  },
  data() {
    return {
      orgDetails: {},
    };
  },
  computed: {
    talentReportPopup() {
      return this.$store.state.modals.talentReportPopup;
    },
    reportUrl() {
      return this.$store.state.user.reportUrl;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.user.userData;
    },
  },
  methods: {
    getOrgDetails(orgId) {
      this.$store.commit("modals/SET_UNIVERSAL_LOADING", true);
      this.$store
        .dispatch("user/getOrgDetails", orgId)
        .then((res) => {
          this.orgDetails = res;
        })
        .catch(() => {
          this.orgDetails = {};
        })
        .finally(() => {
          this.$store.commit("modals/SET_UNIVERSAL_LOADING", false);
        });
    },
    pickReward() {
      let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { gborgid } = this.$route.query;
      let formId = "";
      if (this.orgDetails?.slug === "gala") {
        formId = "n7isLdQI";
      } else {
        formId = "s5eO9qla";
      }
      const link = `https://gtbrdd.typeform.com/to/${formId}#first_name=${encodeURIComponent(
        this.userData.firstName
      )}&email=${this.userData.email}&org=${this.orgDetails.slug}&gbuid=${
        this.userData._id
      }&gborgid=${gborgid}&orgname=${
        this.orgDetails.name
      }&tzn=${encodeURIComponent(timeZone)}`;
      this.$store.commit("modals/OPEN_REPORT_POPUP", true);
      this.$store.commit("user/SET_REPORT_URL", link);
    },
  },
  beforeMount() {
    this.isUserLoggedIn ? this.getOrgDetails(this.$route.query.gborgid) : "";
  },
};
</script>

<style lang="scss">
.marketplace {
  height: 100vh;
  text-align: center;
  font-size: 1.3em;
  background-image: url("../../assets/images/marketplace/bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: -2.5em;
  &__heading {
    font-size: 2.25em;
    font-weight: 700;
    color: #101828;
    margin-top: 1em;
  }
  &__subheading {
    font-size: 1.25em;
    font-weight: 400;
    color: #98a2b3;
    margin-top: 3em;
  }
  &__btn {
    padding: 0.5em 1em;
    border-radius: 2em;
    border: none;
    color: #fcfdff;
    font-weight: 600;
    font-size: 1.2em;
    background: linear-gradient(90deg, #f29805 0%, #f5bc2a 100%);
    margin-top: 3em;
  }
  &__container {
    width: 50%;
  }
}

@media only screen and (max-width: 991px) {
  .marketplace {
    &__heading {
      font-size: 2em;
    }
    &__subheading {
      font-size: 1em;
    }
    &__btn {
      font-size: 1em;
    }
  }
}
@media only screen and (max-width: 746px) {
  .marketplace {
    &__heading {
      font-size: 1.5em;
    }
    &__subheading {
      font-size: 0.85em;
      margin-top: 2.5em;
    }
    &__container {
      width: 75%;
    }
  }
}
@media only screen and (max-width: 520px) {
  .marketplace {
    &__heading {
      font-size: 1.2em;
    }
  }
}
@media only screen and (max-width: 440px) {
  .marketplace {
    &__btn {
      font-size: 0.85em;
    }
  }
}
@media only screen and (max-width: 370px) {
  .marketplace {
    &__btn {
      font-size: 0.75em;
    }
  }
}
</style>
